import { useEffect, useRef } from 'react';
import { useAuthData } from './use-auth-data';
import { api } from '~/trpc-extra/api';

export const useAutoSwitchOrg = (projectId: string | undefined) => {
  const { activeOrg, orgHelper, refreshAuthInfo } = useAuthData();
  const trpcUtils = api.useUtils();
  const switchingRef = useRef(false);

  const { data: ownerOrgId } = api.project.getOwnerOrgId.useQuery(
    { projectId: projectId! },
    { enabled: !!projectId, staleTime: Infinity, retry: false },
  );

  const { mutateAsync: updateActiveTeam } = api.team.updateActiveTeam.useMutation();

  useEffect(() => {
    if (!ownerOrgId || !activeOrg || switchingRef.current) {
      return;
    }
    if (ownerOrgId === activeOrg.orgId) {
      return;
    }

    const userOrgs = orgHelper?.getOrgs();
    if (!userOrgs?.some((org) => org.orgId === ownerOrgId)) {
      return;
    }

    const doSwitch = async () => {
      switchingRef.current = true;
      try {
        await updateActiveTeam({ teamId: ownerOrgId });
        await refreshAuthInfo();
        await trpcUtils.invalidate();
      } finally {
        switchingRef.current = false;
      }
    };

    void doSwitch();
  }, [ownerOrgId, activeOrg, orgHelper, updateActiveTeam, refreshAuthInfo, trpcUtils]);
};
